import { combineReducers } from 'redux'
import dataReducer from 'lib/reducers/dataReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import { currentProfileTypes } from 'actions/types'

const initialState = null
const baseType = currentProfileTypes.FETCH_CURRENT_PROFILE

const reducer = combineReducers({
  data: dataReducer({ initialState, baseType }),
  requestState: requestStateReducer(baseType),
})

export default reducer
